export default __webpack_public_path__ + "static/media/suitcase.3f156a06.svg";